<template>
  <div class="container-fluid">
    <div class="card card-default custom-card-height">
      <div class="card-header feature-header">
        <div class="row g-2">
          <div class="col-auto me-auto">
            <CardTitleComponent />
          </div>

          <div class="col-auto">
            <SearchComponent v-model="searchText" @search="onSearch" @clear="clearSearch" />
          </div>

          <div class="col-auto">
            <div class="unified-daterangepicker form-group mb-0">
              <ejs-daterangepicker id="syncLogDateRange" :zIndex="10000" :change="onchangeDateRange" format="yyyy-MM-dd"
                :startDate="manageFilter.startDate" :endDate="manageFilter.endDate"
                :placeholder="$t('selectRange')" :firstDayOfWeek="1"></ejs-daterangepicker>
            </div>
          </div>         
          <div class="col-auto" v-if="userStore.userInfo.isHost">
            <div class="dropdown-container">
              <select class="dropdown-select" v-model="subscriptionId" @change="onSubscriptionChanged">
                <option value="">{{ $t('selectCustomer') }}</option>
                <option v-for="item in subscriptionList" :key="item.id" :value="item.id">
                  {{ item.organizationName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-auto" v-if="!userStore.userInfo.isHost || Boolean(subscriptionId)">        
              <div v-if="moduleList?.length > 0" class="form-group mb-0">           
              <ejs-dropdownlist id="moduleList" ref="moduleList" :popup-width="'auto'" v-model="moduleId"
                :dataSource="moduleList.map((m) => ({ id: m.id, text: m.displayName }))"
                :placeholder="$t('select') + ' ' + $t('module')" :showClearButton="false"
                :fields="{ text: 'text', value: 'id' }" @change="changeModule">
              </ejs-dropdownlist>
            </div>
          </div>

          <div class="col-auto" v-if="moduleId && companies?.length > 0">
            <div class="form-group mb-0">
            <ejs-dropdownlist id="companyList" ref="companyList" :popup-width="'auto'" v-model="companyId"
              :dataSource="companies.map((c) => ({ id: c.id, text: c.name }))"
              :placeholder="$t('select') + ' ' + $t('company')" :showClearButton="false"
              :fields="{ text: 'text', value: 'id' }" @change="onCompanyChange">
            </ejs-dropdownlist>
            </div>
          </div>
          <div class="col-auto mt-3" ">
            
              <ejs-checkbox label="Show Pending" v-model="includePending" @change="onFilterChange">
              </ejs-checkbox>
        
          </div>
          <div class="col-auto">
            <button class="btn btn-outline-primary" :disabled="!(moduleId > 0)" @click="dataStateChange(
              initState(pageSettings.skip, pageSettings.take)
            )">
              <i class="fas fa-sync-alt me-1"></i> {{ $t('refresh') }}
            </button>
          </div>

        </div>
      </div>

      <div class="card-body card-body-custom-layout">
        <div class="card-body-grid ">
          <ejs-grid ref="gridSyncLog" :dataSource="data" :allowPaging="true" 
            :allowResizing="true" :pageSettings="pageSettings" :locale="locale" :rowHeight="38" height="100%"
            :allowSorting="true" :searchSettings="searchOptions"  :dataStateChange="dataStateChange" :commandClick="commandClick">
            <e-columns>
              <e-column :headerText="isFinanceModule() ? $t('legalEntity') : $t('companyName')" field="CompanyName"
                :allow-sorting="false" width="200" freeze="Left"></e-column>
              <e-column :headerText="$t('runStatus')" field="RunStatusId" textAlign="Center" width="150"
                :template="'RunStatusTemplate'">
                <template v-slot:RunStatusTemplate="{ data }">
                  <span v-if="data.statusId === 1" class="badge badge-sm text-bg-info">{{ $t('pending') }}</span>
                  <span v-else-if="data.statusId === 2" class="badge badge-sm text-bg-dark">{{ $t('running')
                  }}</span>
                  <span v-else-if="data.statusId === 3" class="badge badge-sm text-bg-success">{{ $t('success')
                  }}</span>
                  <span v-else-if="data.statusId === 4" class="badge badge-sm text-bg-danger">{{ $t('errors')
                  }}</span>
                  <span v-else-if="data.statusId === 5" class="badge badge-sm text-bg-warning">{{ $t('warnings')
                  }}</span>
                  <span v-else-if="data.statusId === 6" class="badge badge-sm text-bg-danger">{{
                    $t('forcefullyTerminated')
                  }}</span>
                  <span v-else>
                    <a href="#" data-bs-toggle="tooltip" :title="getHoverMessage(data.runStatusId, data.hasError)
                      "><i :class="getRunStatusIcon(data.runStatusId, data.hasError)
                        "></i>
                    </a>
                  </span>
                </template>
              </e-column>

              <e-column :headerText="$t('requestedAt')" field="RequestedAt" type="date"
                format="yyyy-MM-dd hh:mm a"></e-column>
              <e-column :headerText="$t('requestedBy')" field="RequestedBy" :template="'requestedByTemplate'">
                <template v-slot:requestedByTemplate="{ data }">
                  <span v-if="data.requestedBy == 'FortnoxAPI'" class="badge badge-sm text-bg-success">{{ data.requestedBy
                  }}</span>
                  <span v-if="data.requestedBy == 'NetVisorAPI'" class="badge badge-sm text-bg-success">{{ data.requestedBy
                  }}</span>
                  <span v-else></span>
                </template>

              </e-column>
              <e-column :headerText="$t('startedAt')" field="StartedAt" type="date"
                format="yyyy-MM-dd hh:mm a"></e-column>
              <e-column :headerText="$t('completedAt')" field="CompletedAt" type="date"
                format="yyyy-MM-dd hh:mm a"></e-column>
              <e-column :headerText="$t('errorMessage')" field="ErrorMessage" width="350"></e-column>
              <e-column :headerText="$t('isFullSync')" field="IsFullSync" textAlign="Center" width="100"
                :template="'IsFullSyncTemplate'">
                <template v-slot:IsFullSyncTemplate="{ data }">
                  <span v-if="data.isFullSync" class="badge badge-sm text-bg-success">{{ $t('yes') }}</span>
                  <span v-else></span>
                </template>
              </e-column>
              <e-column :headerText="$t('jobRunId')" field="JobRunId" :template="'JobRunIdTemplate'">
                <template v-slot:JobRunIdTemplate="{ data }">
                  <div class="job-run-cell">
                    <a
                      href="javascript:void(0)"
                      v-if="data.jobRunId"
                      class="me-2 action-link job-run-action"
                      :title="$t('jobRunStatus')"
                      @click="getJobRunStatus(data.jobRunId)"
                    >
                      <i class="e-eye e-icons" style="font-size: 0.76em;"></i>
                    </a>
                    <span>{{ data.jobRunId }}</span>
                  </div>                </template>
              </e-column>
              <e-column :headerText="$t('tryCount')" field="TryCount" width="100" textAlign="Center"></e-column>
              <e-column :headerText="'Force Sync Date'" field="forceSyncDate" format="yyyy-MM-dd hh:mm a"></e-column>
              <e-column :headerText="$t('actions')" textAlign="Center" freeze="Right" width="100":template="'actionTemplate'">
                    <template v-slot:actionTemplate="{ data }">
                        <div class="btn-group actions-row" role="group"
                            aria-label="Row actions">
                            <a href="javascript:void(0)" class="ms-2 action-link" title="View Details"
                                @click="actionColumnClick( data)">
                                <i class="e-eye e-icons" style="font-size: 0.76em;"></i>
                            </a>
                        </div>
                    </template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="requestedModal" role="dialog">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t('syncLogDetails') }}</h4>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
            @click="close(modalType.requestedModal)">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-2">  
            <div class="property-value-grid sync-log-details-grid">
              <ejs-grid ref="gridSyncLogDetails" :dataSource="details.data" :toolbar="details.toolbar" 
                :allowPaging="true" :allowResizing="true" :pageSettings="details.pageSettings" :locale="locale"
                :rowHeight="30" :allowSorting="true" :searchSettings="details.searchOptions"
                :dataStateChange="dataStateChangeDetails">
                <e-columns>
                  <e-column :headerText="$t('entity')" field="Entity"></e-column>
                  <e-column :visible="moduleList.filter((x) => x.id == moduleId)[0]?.name ==
                    moduleEnumData.Finance.id" :headerText="$t('sourceSystem')" field="sourceSystem"></e-column>
                  <e-column :headerText="$t('runStatus')" field="RunStatusId" width="130" textAlign="Center"
                    :template="'RunStatusTemplate'">
                    <template v-slot:RunStatusTemplate="{ data }">
                      <span v-if="data">
                        <a href="#" data-bs-toggle="tooltip" :title="getHoverMessage(data.runStatusId, data.hasError)
                          "><i :class="getRunStatusIcon(data.runStatusId, data.hasError)
                            "></i></a>
                      </span>
                    </template>
                  </e-column>
                  <e-column :headerText="$t('errorMessage')" field="ErrorMessage" width="465"
                    :template="'ErrorMessageTemplate'">
                    <template v-slot:ErrorMessageTemplate="{ data }">
                      <a class="copy-icon" v-if="data.errorMessage && data.errorMessage.length > 0" href="#"
                        data-bs-toggle="tooltip" :title="$t('copy')">
                        <i class="fas fa-copy" @click="copyToClipboard(data.errorMessage)"></i> </a><span
                        v-if="data.errorMessage">{{
                          data.errorMessage
                        }}</span>
                    </template>
                  </e-column>
                  <e-column :headerText="$t('startedAt')" field="StartedAt" type="date" width="155"
                    format="yyyy-MM-dd hh:mm a"></e-column>
                  <e-column :headerText="$t('completedAt')" field="CompletedAt" width="155" type="date"
                    format="yyyy-MM-dd hh:mm a"></e-column>
                  <e-column :headerText="$t('syncFromDate')" field="syncFromDate" width="155" type="date"
                    format="yyyy-MM-dd hh:mm a"></e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
 
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-outline-close" @click="close(modalType.requestedModal)">
            <i class="fas fa-times me-1"></i>{{ $t('close') }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <div class="modal fade" id="jobRunStatusModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t('jobRunStatus') }}</h4>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
            @click="close(modalType.jobRunStatusModal)">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card-body">

            <div class="row mb-2">
              <div class="col-md-4 fw-bold text-secondary">{{ $t('name') }}:</div>
              <div class="col-md-8">{{ jobRunStatus?.name }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4 fw-bold text-secondary">{{ $t('jobRunId') }}</div>
              <div class="col-md-8">{{ jobRunStatus?.instanceId }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4 fw-bold text-secondary">{{ $t('runtimeStatus') }}</div>
              <div class="col-md-8 text-success">{{ jobRunStatus?.runtimeStatus }}</div>
            </div>
            <hr />
            <h5 class="text-dark mb-3">Input Details</h5>
            <div class="row mb-2">
              <div class="col-md-4 fw-bold text-secondary">{{ $t('subscriptionId') }}</div>
              <div class="col-md-8">{{ jobRunStatus.input?.subscriptionId }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4 fw-bold text-secondary">{{ $t('partitionKey') }}</div>
              <div class="col-md-8">{{ jobRunStatus.input?.partitionKey }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4 fw-bold text-secondary">{{ $t('rowKey') }}</div>
              <div class="col-md-8">{{ jobRunStatus.input?.rowKey }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4 fw-bold text-secondary">{{ $t('forceSync') }}</div>
              <div class="col-md-8"><span class="badge bg-secondary">{{ jobRunStatus.input?.forceSync }}</span></div>
            </div>
            <!-- <hr />
            <div class="row mb-2">
              <div class="col-md-4 fw-bold text-secondary">Created Time:</div>
              <div class="col-md-8">{{jobRunStatus.createdTime}}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4 fw-bold text-secondary">Last Updated:</div>
              <div class="col-md-8">{{jobRunStatus.lastUpdatedTime}}</div>
            </div> -->
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-outline-close" data-bs-dismiss="modal"
            @click="close(modalType.jobRunStatusModal)"><i class="fas fa-times me-1"></i>{{ $t('close')
            }}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>

<script lang="ts" src="./SyncLog.service.ts">
import './SyncLogComponent.css';</script>
